module.exports = __webpack_public_path__ + "assets/img/service3.8b4329f7.png";